import { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import {
  Box, Button, Container, TextField,
  Typography, Alert, Paper
} from "@mui/material";
import Header from "../../components/Header";

export default function AdminResetPassword() {
  const { token } = useParams();
  const navigate  = useNavigate();

  const [newPassword, setNewPassword]         = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [status, setStatus]   = useState("idle");
  const [errorMsg, setErrorMsg] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrorMsg("");

    if (newPassword.length < 8) {
      setErrorMsg("Le mot de passe doit contenir au moins 8 caractères.");
      return;
    }
    if (newPassword !== confirmPassword) {
      setErrorMsg("Les mots de passe ne correspondent pas.");
      return;
    }

    try {
      setStatus("loading");
      await axios.post("https://api.komorotel.com/api/authAdmin/reset-password", {
        token,
        newPassword,
      });
      setStatus("success");
    } catch (err) {
      setErrorMsg(err.response?.data?.message || "Lien invalide ou expiré.");
      setStatus("error");
    }
  };

  return (
    <Box className="w-100 h-100">
      <Header />
      <Container maxWidth="sm" sx={{ display: "flex", flexDirection: "column", alignItems: "center", mt: 28 }}>

        <Typography variant="h4" component="h1" align="center" gutterBottom>
          <span style={{ background: "var(--k-green)", color: "#fff", padding: "0.5rem 1rem", borderRadius: "8px" }}>
            Komorotel
          </span>
        </Typography>

        <Paper elevation={3} sx={{ p: 4, width: "100%", mt: 4 }}>

          {status === "success" ? (
            <Box sx={{ textAlign: "center", py: 2 }}>
              <Typography variant="h6" sx={{ color: "var(--k-green)" }} gutterBottom>
                ✓ Mot de passe réinitialisé
              </Typography>
              <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
                Vous pouvez maintenant vous connecter avec votre nouveau mot de passe.
              </Typography>
              <Button variant="contained" color="primary" onClick={() => navigate("/admin")}>
                Se connecter
              </Button>
            </Box>
          ) : (
            <>
              <Typography variant="h5" align="center" gutterBottom>
                Nouveau mot de passe
              </Typography>
              <Typography variant="body2" color="text.secondary" align="center" sx={{ mb: 3 }}>
                Choisissez un nouveau mot de passe pour votre compte administrateur.
              </Typography>

              <Box component="form" onSubmit={handleSubmit} noValidate>
                <TextField
                  label="Nouveau mot de passe"
                  type="password"
                  fullWidth
                  margin="normal"
                  value={newPassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                  required
                />
                <TextField
                  label="Confirmer le mot de passe"
                  type="password"
                  fullWidth
                  margin="normal"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  required
                />

                {errorMsg && (
                  <Alert severity="error" sx={{ mt: 1 }}>{errorMsg}</Alert>
                )}

                <Button
                  type="submit"
                  fullWidth
                  variant="contained"
                  color="primary"
                  sx={{ mt: 3, py: 1.5 }}
                  disabled={status === "loading"}
                >
                  {status === "loading" ? "Enregistrement..." : "Enregistrer le nouveau mot de passe"}
                </Button>
              </Box>
            </>
          )}

        </Paper>
      </Container>
    </Box>
  );
}